module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "clearable": true,
      "required": false
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Rodzaj wydarzenia",
      "required": "",
      "error": _vm.errors['event_type']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz typ wydarzenia"
    },
    model: {
      value: (_vm.form.event_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "event_type", $$v)
      },
      expression: "form.event_type"
    }
  }, _vm._l((_vm.types), function(type) {
    return _c('el-option', {
      key: type,
      attrs: {
        "label": _vm.translateType(type),
        "value": type
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tła",
      "error": _vm.errors['bg_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bg_color", $$v)
      },
      expression: "form.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tekstu",
      "error": _vm.errors['text_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.text_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "text_color", $$v)
      },
      expression: "form.text_color"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78155864"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/WhatWePlayWidget.vue
// module id = 779
// module chunks = 0